export default __webpack_public_path__ + "static/media/centos.43594244.svg";